import {newsFeed, NewsFeed} from "./news-feed/NewsFeedComponent";
import {NewsHeadline, newsHeadline} from "./news-headline/NewsHeadlineComponent";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.news-feed`;
    return angular.module(moduleName, [])
                  .component(NewsFeed, newsFeed())
                  .component(NewsHeadline, newsHeadline())
                  .name;
}
